const $ = jQuery

class search {
  constructor () {
    this.$window                        = $(window)
    this.$document                      = $(document)
    this.loadMoreSearchSelector         = '#load-more-search'
    this.searchContainer                = '.search-container'


    this.$document.on('click', this.loadMoreSearchSelector, (event) =>{
      const $clickedButton = $(event.currentTarget)
      const currentPage = parseInt($clickedButton.attr('data-page'));
      const searchQuery = $clickedButton.attr('data-query');
      const excludeIds = $clickedButton.attr('data-exclude');
      const globalCount = parseInt($clickedButton.attr('data-global-count'));
      const maxPage = parseInt($clickedButton.attr('data-max-page'));

      $(this.searchContainer).addClass('loading');
      $(this.loadMoreSearchSelector).addClass('loading');
      
      $.ajax({
        type: 'POST',
        url: window.ajaxUrl,
        data: {
          action: 'load_more_search',
          page: currentPage + 1,
          s: searchQuery,
          exclude: excludeIds,
          global_count: globalCount
        }
      }).success((res) => {
        if (res.success && res.data) {
          $(this.searchContainer).append(res.data);
          $clickedButton.attr('data-page', currentPage + 1);

          if (currentPage + 1 >= maxPage) {
            $(this.loadMoreSearchSelector).hide();
          }
        } else {
          $(this.loadMoreSearchSelector).hide();
        }
        $(this.searchContainer).removeClass('loading');
        $(this.loadMoreSearchSelector).removeClass('loading');
      }).fail((response) => {
        console.log("Fail");
      });
    })
  }

  onWindowResize (windowWidth) {
    
  }
}

export default search